// Clase para guardame en el contexto la observacion seleccionada

import React, { createContext, useState } from 'react';

export const ObservationContext = createContext();

export const ObservationProvider = ({ children }) => {
  const [observationSelected, setObservationSelected] = useState({});

  return (
    <ObservationContext.Provider value={{ observationSelected,  setObservationSelected}}>
      {children}
    </ObservationContext.Provider>
  );
};